// client/src/components/wetakeover/PricingPreview.jsx
import React from 'react';

const PRICING = {
  mid: { qrtCost: 100 },
  high: { qrtCost: 180 },
};

const PricingPreview = ({ tier, numCreators, qrtsPerCreator, isMobile = false }) => {
  const calculatePricing = () => {
    if (!tier) {
      return {
        totalQRTs: 0,
        total: 0,
      };
    }

    const pricing = PRICING[tier];
    const totalQRTs = numCreators * qrtsPerCreator;
    const total = totalQRTs * pricing.qrtCost;

    return {
      totalQRTs,
      total,
    };
  };

  const pricing = calculatePricing();

  if (isMobile) {
    // Mobile: Sticky bottom drawer
    return (
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-zinc-950/95 backdrop-blur-xl border-t border-white/10 px-6 py-4 md:hidden">
        <div className="flex items-center justify-between">
          <div>
            <div className="text-xs text-white/50">Estimated Total</div>
            <div className="text-2xl font-bold text-yellow-300">
              ${pricing.total.toLocaleString()}
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Desktop: Sticky sidebar
  return (
    <div className="sticky top-6 bg-white/5 border border-white/10 backdrop-blur-md rounded-3xl p-6">
      {/* Header */}
      <h3 className="text-xl font-bold text-white mb-6">Live Pricing Preview</h3>

      {/* Configuration */}
      <div className="mb-6">
        <div className="text-sm text-white/60 mb-3">Configuration</div>
        <div className="space-y-1 text-white">
          <div className="flex justify-between">
            <span className="text-white/80">Tier:</span>
            <span className="font-semibold">
              {tier ? (tier === 'mid' ? 'Mid-Tier' : 'High-Tier') : '--'}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-white/80">Creators:</span>
            <span className="font-semibold">{numCreators || '--'}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-white/80">Total QRTs:</span>
            <span className="font-semibold">{pricing.totalQRTs || '--'}</span>
          </div>
        </div>
      </div>

      <div className="h-px bg-white/10 my-4" />

      {/* Pricing Breakdown */}
      {tier && (
        <div className="mb-6">
          <div className="text-sm text-white/60 mb-3">Pricing Breakdown</div>

          <div className="space-y-3">
            {/* QRTs */}
            <div>
              <div className="text-white/80 text-sm">Quote Retweets</div>
              <div className="flex justify-between items-center">
                <span className="text-white/60 text-sm">
                  {pricing.totalQRTs} × ${PRICING[tier].qrtCost}
                </span>
                <span className="text-yellow-300 font-semibold">
                  ${pricing.total.toLocaleString()}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="h-px bg-white/10 my-4" />

      {/* Total */}
      <div className="flex justify-between items-center">
        <span className="text-xl text-white font-semibold">TOTAL</span>
        <span className="text-3xl text-yellow-300 font-bold">
          ${pricing.total.toLocaleString()}
        </span>
      </div>
    </div>
  );
};

export default PricingPreview;
export { PRICING };
